<template>
  <div>
    <AppNavigation></AppNavigation>

    <v-main>
      <router-view></router-view>
    </v-main>
  </div>
</template>

<script>
import AppNavigation from "@/components/app/AppNavigation.vue";

export default {
  components: {
    AppNavigation
  }
};
</script>

<style lang="scss" scoped>
.v-main {
  height: 100vh;
  overflow: hidden;
}
</style>

<style lang="scss"></style>
